import { render, staticRenderFns } from "./Delete-modal.vue?vue&type=template&id=6c4138d6&"
import script from "./Delete-modal.vue?vue&type=script&lang=js&"
export * from "./Delete-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports